import styled from 'styled-components';
import HappyBackToTopSvg from './happyBackToTop.svg';

const HappyBackToTopIcon = styled(HappyBackToTopSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  g {
    path:last-child {
      fill: ${props => props.fill || props.theme.colors.ash.base};
    }
  }
`;

export default HappyBackToTopIcon;
